var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/add"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.48 15.6186V15.62V32.38C43.48 35.9206 42.4266 38.6863 40.5464 40.5664C38.6663 42.4466 35.9006 43.5 32.36 43.5H15.62C12.0794 43.5 9.31384 42.4466 7.43377 40.5642C5.55364 38.6817 4.5 35.9109 4.5 32.36V15.62C4.5 12.0794 5.55343 9.31368 7.43355 7.43355C9.31368 5.55343 12.0794 4.5 15.62 4.5H32.38C35.9207 4.5 38.6862 5.55347 40.5637 7.43333C42.4411 9.31309 43.4897 12.0784 43.48 15.6186ZM26 36V26H36C37.0961 26 38 25.0961 38 24C38 22.9039 37.0961 22 36 22H26V12C26 10.9039 25.0961 10 24 10C22.9039 10 22 10.9039 22 12V22H12C10.9039 22 10 22.9039 10 24C10 25.0961 10.9039 26 12 26H22V36C22 37.0961 22.9039 38 24 38C25.0961 38 26 37.0961 26 36Z",
    fill: "white",
    stroke: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.83798478bac9cfbdd8768dd83bdd7445.svg";
export { ForwardRef as ReactComponent };